import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './style.pcss';
const cx = classNames.bind(styles);

const Progress = ({ percent = 0, bg = 'transparent', className = '' }) => (
  <div className={cx('wrap', className)}>
    <div className={cx('progress')}>
      <div
        className={cx('progress__line')}
        style={{
          width: `${parseInt(percent, 10)}%`,
          backgroundColor: bg,
        }}
      />
    </div>
  </div>
);

Progress.propTypes = {
  percent: PropTypes.number,
  bg: PropTypes.string,
  className: PropTypes.string,
};

export default Progress;
